import React from 'react';
import PropTypes from 'prop-types';
import './UserSuggestion.css';
import UserCard from '../UserCard/UserCard';

const UserSuggestion = ({ title }) => {
  return (
    <section className="section pd">
      <h4>{title}</h4>
      <UserCard />
      <UserCard />
      <UserCard />
      <UserCard />
    </section>
  );
};

UserSuggestion.propTypes = {
  title: PropTypes.string,
};

UserSuggestion.defaultProps = {
  title: 'Suggested Top  influencers to Holla',
};

export default UserSuggestion;
